$(function () {
    // cart
    var cart = $('.cart'),
        cartItems = $('.cart__count', cart),

        wishlist = $('.wishlist'),
        wishlistItems = $('.wishlist__count', wishlist);

    function initActionEvents() {
        $('body').on('click', '.action--buy, .cart-add .btn', addToCart);
        $('body').on('click', '.favorite-add', addToWishlist);
        $('body').on('click', '.remove-item', removeFromWishlist);
        $('body').on('click', '.action--love', addToWishlist);
    }

    function addToCart(e) {
				var max = $('[name=quantity]').attr('max');
        var qty = parseInt($('[name=quantity]', $(this).closest('form')).val(), 10) || 1;
				var total = Number(cartItems.text()) + qty;
				if (max) {
					total = Math.min(max, total);
				}

				cart.addClass('cart--animate');
        setTimeout(function() {
          cartItems.text(total);
        }, 200);
        cartItems.one('webkitAnimationEnd oanimationend msAnimationEnd animationend', function(e) {
            cart.removeClass('cart--animate');
        });
    }

    function addToWishlist(e) {
        e.preventDefault();
        $.get($(this).attr('href'));
        wishlist.addClass('wishlist--animate');
        setTimeout(function() { wishlistItems.text((Number(wishlistItems.text()) + 1)); }, 200);
        wishlistItems.one('webkitAnimationEnd oanimationend msAnimationEnd animationend',
        function(e) {
            wishlist.removeClass('wishlist--animate');
        });
    }

    function removeFromWishlist(e) {
        e.preventDefault();
        wishlist.addClass('wishlist--animate');
        setTimeout(function() { wishlistItems.text((Number(wishlistItems.text()) - 1)); }, 200);
        wishlistItems.one('webkitAnimationEnd oanimationend msAnimationEnd animationend',
        function(e) {
            wishlist.removeClass('wishlist--animate');
        });
    }

    initActionEvents();
});
